import { useTheme } from 'styled-components';

export const triangleHeight = 4;
export const triangleWidth = 12;
export const triangleY = 8;

export const Triangle: React.FC<React.ComponentPropsWithoutRef<'svg'>> = (props) => {
  const theme = useTheme();

  return (
    <svg fill="none" height={triangleHeight} viewBox="0 0 10 4" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5 4L0.669872 0.25L9.33013 0.25L5 4Z" fill={theme.main.deepBlue} />
    </svg>
  );
};

export const InverseTriangle: React.FC<React.ComponentPropsWithoutRef<'svg'>> = (props) => {
  const theme = useTheme();

  return (
    <svg fill="none" height={triangleHeight} viewBox="0 0 10 4" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5 0L0.669872 3.75L9.33013 3.75L5 0Z" fill={theme.secondary.softBlue1} />
    </svg>
  );
};
